import { COUNTED_SHOTS, bestShotsTotal, formatDecimalTenths, isParseError, parseShotPoints, parseWholeShotPoints } from './shooting';

/** Keep only what a shot can contain. Comma keypads type "9,7"; treat it as 9.7. */
export function normalizeShotDraft(value: string): string {
  const cleaned = value.replace(',', '.').replace(/[^\d.]/g, '');
  const dot = cleaned.indexOf('.');
  const single = dot === -1 ? cleaned : cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
  return single.slice(0, 4);
}

/** True once a shot is fully typed (it has its one decimal), so the form can save it and move on. */
export function isCompleteShot(draft: string): boolean {
  return /^\d{1,2}\.\d$/.test(draft) && !isParseError(parseShotPoints(draft));
}

/** Tenths for a valid draft, or null when it is empty or not a valid shot. */
export function draftTenths(draft: string): number | null {
  if (!draft.trim()) return null;
  const parsed = parseShotPoints(draft);
  return isParseError(parsed) ? null : parsed.tenths;
}

export function wholeDraftTenths(draft: string): number | null {
  if (!draft.trim()) return null;
  const parsed = parseWholeShotPoints(draft);
  return isParseError(parsed) ? null : parsed.tenths;
}

export function shotDisplay(tenths: number): string {
  return formatDecimalTenths(tenths);
}

/**
 * Running best-N total of the shots typed so far (valid ones only), how many there are, and which
 * shot numbers (1-based, by position in `drafts`) are dropped. The server works out the real total.
 */
export function runningTotal(
  drafts: readonly string[],
  countedShots: number = COUNTED_SHOTS,
): { tenths: number; count: number; dropped: Set<number> } {
  const shots: { shotNumber: number; pointsTenths: number }[] = [];
  drafts.forEach((draft, index) => {
    const value = draftTenths(draft);
    if (value != null) shots.push({ shotNumber: index + 1, pointsTenths: value });
  });
  if (countedShots >= drafts.length) {
    return { tenths: shots.reduce((sum, shot) => sum + shot.pointsTenths, 0), count: shots.length, dropped: new Set() };
  }
  const best = bestShotsTotal(shots, Math.min(countedShots, drafts.length));
  return { tenths: best.totalTenths, count: shots.length, dropped: best.dropped };
}
